export default {
  // api请求地址
  //API_URL: 'http://1.1.1.3:8002'
  //API_URL: 'https://opwf-backend.ushow.media'
  //API_URL: 'http://192.168.2.108:8000',
  API_URL: 'https://opwf-backend.ushow.media',
  UPLOAD_URL: 'https://opwf-backend.ushow.media'
  // API_URL: 'https://opwf-backend-test.ushow.media',
  // UPLOAD_URL: 'https://opwf-backend-test.ushow.media'
  //UPLOAD_URL: 'http://192.168.2.108:8000'
  // API_URL: 'http://10.3.0.78:8000',
  // UPLOAD_URL: 'http://10.3.0.78:8000',

}



//////////////////
// WEBPACK FOOTER
// ./config/urls.js
// module id = tRh+
// module chunks = 75